import { Select } from "shared/components";
import { ApplicantType } from "shared/types";
import { roles } from "shared/constants/roles";
import { useMemo } from "react";
import { TemplateBaseSetting } from "types/landlord/verificationTemplate";

interface Props {
  value: ApplicantType;
  onChange: (role: ApplicantType) => void;
  isDisabled: boolean;
  disabledRoles?: ApplicantType[];
  className?: string;
  template?: Record<ApplicantType, TemplateBaseSetting>;
}

export const RoleSelect = ({
  value,
  onChange,
  isDisabled,
  className,
  template,
  disabledRoles: _disabledRoles = []
}: Props) => {
  const disabledRoles = useMemo(() => {
    return Object.keys(template || {}).filter(
      (key) => template?.[key]?.enabled_screening_services === false
    );
  }, [template]);

  const updatedRoles = roles.map((role) => {
    const disabledRole =
      _disabledRoles.includes(role.value) || disabledRoles.includes(role.value);
    return {
      ...role,
      isDisabled: disabledRole,
      tooltip: disabledRole ? "This role is not available." : undefined
    };
  });

  return (
    <div>
      <Select
        className={className}
        id="role"
        options={updatedRoles}
        menuPortalTarget={document.body}
        placeholder="Select role"
        isDisabled={isDisabled}
        value={value}
        onChange={(e) => onChange(e.target.value as ApplicantType)}
      />
    </div>
  );
};
